// extracted by mini-css-extract-plugin
export default {"icon":"PrintButton--icon--75bc93","print":"PrintButton--print--95df03"};